export const BREAKPOINT = {
  sm: "sm",
  md: "md",
  lg: "lg",
  xl: "xl",
};

export const FONT_SIZE_KEYS = ["xxs", "xs", "sm", "md", "lg", "xl", "xxl"];
